<template>
  <div class="open-box">
    <div class="open-door open-door1">
      <div class="bg-top">
        <div class="bg-inner">
          <div class="bg-bk"></div>
          <div class="anim-img"></div>
        </div>
        <div class="logo-inner">
          <div class="abs-full app-logo0"></div>
          <div class="abs-full app-logo1"></div>
          <div class="light-mask"></div>
        </div>
      </div>
      <div class="bg-btm">
        <div class="bg-inner">
          <div class="anim-img"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style scoped lang="scss">
/* input placeholder color */
.open-box {
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  // width: 100%;
  // height: 100%;
  z-index: 2000;
  background-color: rgba(0, 0, 0, 0.8);
  margin: 0 auto;
  height: 100vh;
  width: 420px;
}

.open-box .open-door {
  position: relative;
  width: 100%;
  height: 100%;
}

.open-box .open-door .bg-inner {
  position: relative;
  width: 100%;
  height: 100%;
}

.open-box .open-door .bg-top {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  height: 50%;
  -webkit-animation: openTopKf 1s ease-out 0s 1 forwards;
  animation: openTopKf 1s ease-out 0s 1 forwards;
}

@-webkit-keyframes openTopKf {
  0% {
    top: 0;
  }

  100% {
    top: -900px;
  }
}

@keyframes openTopKf {
  0% {
    top: 0;
  }

  100% {
    top: -900px;
  }
}

@-webkit-keyframes openTopKf1 {
  0% {
    top: -900px;
  }

  40% {
    top: 0;
  }

  60% {
    top: 0;
  }

  100% {
    top: -900px;
  }
}

@keyframes openTopKf1 {
  0% {
    top: -900px;
  }

  40% {
    top: 0;
  }

  60% {
    top: 0;
  }

  100% {
    top: -900px;
  }
}

.open-box .open-door .bg-top .bg-bk {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background-color: #000;
}

.open-box .open-door .bg-top .anim-img {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 106.67*4.2px;
  background-position: center bottom;
  background-size: 100% 92.67*4.2px;
  background-repeat: no-repeat;
  background-image: url("../../assets/images/open_top.png");
}

.open-box .open-door .bg-top .logo-inner {
  position: relative;
  width: 106px;
  height: 100px;
  margin: -13.33*4.2px 0 0 37.6*4.2px;
}

@-webkit-keyframes openAvatarKf {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

@keyframes openAvatarKf {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.open-box .open-door .bg-top .logo-inner .app-logo0 {
  -webkit-border-radius: 5.33*4.2px;
  border-radius: 5.33*4.2px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 10.67*4.2px 10.67*4.2px;
  background-image: url("../../assets/images/logo.png");
  width: 106px;
  height: 100px;
}

.open-box .open-door .bg-top .logo-inner .app-logo1 {
  background-size: 100% 100%;
  background-image: url("../../assets/images/a_m_1.png");
  width: 106px;
  height: 100px;
  position: absolute;
  top: 0;
}

.open-box .open-door .bg-top .logo-inner .light-mask {
  position: absolute;
  top: -6*4.2px;
  left: -0.8*4.2px;
  width: 20.13*4.2px;
  height: 19.33*4.2px;
  background-size: 100% 100%;
  background-image: url("../../assets/images/a_m_2.png");
  -webkit-animation: lightAnimKf 5s linear 0s infinite;
  animation: lightAnimKf 5s linear 0s infinite;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  opacity: 0;
}

@-webkit-keyframes lightAnimKf {
  0% {
    opacity: 0.1;
    -webkit-transform: rotateZ(0) scale(0.1);
    transform: rotateZ(0) scale(0.1);
  }

  50% {
    opacity: 1;
    -webkit-transform: rotateZ(0deg) scale(1);
    transform: rotateZ(0deg) scale(1);
  }

  100% {
    opacity: 0.1;
    -webkit-transform: rotateZ(0deg) scale(0.1);
    transform: rotateZ(0deg) scale(0.1);
  }
}

@keyframes lightAnimKf {
  0% {
    opacity: 0.1;
    -webkit-transform: rotateZ(0) scale(0.1);
    transform: rotateZ(0) scale(0.1);
  }

  50% {
    opacity: 1;
    -webkit-transform: rotateZ(0deg) scale(1);
    transform: rotateZ(0deg) scale(1);
  }

  100% {
    opacity: 0.1;
    -webkit-transform: rotateZ(0deg) scale(0.1);
    transform: rotateZ(0deg) scale(0.1);
  }
}

.open-box .open-door .bg-btm {
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 50%;
  background-color: #000;
  -webkit-animation: openBtmKf 1s ease-out 0s 1 forwards;
  animation: openBtmKf 1s ease-out 0s 1 forwards;
}

@-webkit-keyframes openBtmKf {
  0% {
    bottom: 0;
  }

  100% {
    bottom: -900px;
  }
}

@keyframes openBtmKf {
  0% {
    bottom: 0;
  }

  100% {
    bottom: -900px;
  }
}

@-webkit-keyframes openBtmKf1 {
  0% {
    bottom: -900px;
  }

  40% {
    bottom: 0;
  }

  60% {
    bottom: 0;
  }

  100% {
    bottom: -900px;
  }
}

@keyframes openBtmKf1 {
  0% {
    bottom: -900px;
  }

  40% {
    bottom: 0;
  }

  60% {
    bottom: 0;
  }

  100% {
    bottom: -900px;
  }
}

.open-box .open-door .bg-btm .anim-img {
  position: absolute;
  top: -17.33*4.2px;
  left: 0;
  width: 100%;
  height: 106.67*4.2px;
  background-position: center top;
  background-size: 100% 97.2*4.2px;
  background-repeat: no-repeat;
  background-image: url("../../assets/images/open_btm.png");
}

.open-box .open-door .logo-box {
  z-index: 3;
}

.open-box .open-door.open-door1 .bg-top {
  -webkit-animation: openTopKf1 1.5s ease-in-out 0s 1 forwards;
  animation: openTopKf1 1.5s ease-in-out 0s 1 forwards;
}

.open-box .open-door.open-door1 .bg-btm {
  -webkit-animation: openBtmKf1 1.5s ease-in-out 0s 1 forwards;
  animation: openBtmKf1 1.5s ease-in-out 0s 1 forwards;
}
</style>